/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import AcessCodeSetup from './AccessCodeSetup';
import {assignAccessCodeISBN, createAccessCardOffer, sendToPCS} from '../../../_thunks/collection.thunk';
import {setSPWAccessCode, setSubscriptionLength} from "../../../_actions/access.code.actions";

function mapStateToProps(state, props) {
    return {
        isAccessCodeGenerateEnabled: !state.activeCollection.accessCodeIsbn,
        collectionId: state.activeCollection.collectionId,
        match: props.match,
        pcsLogs: state.pcsLogs,
        sendAccessCodeToPCS : state.accessCodeSendToPcs,
        spwAccessCode: state.accessCodeSetup.spwAccessCode,
        subscriptionLength: state.accessCodeSetup.subscriptionLength
    };
}

const mapDispatchToProps = dispatch => {
    return {
        generateAccessCodeISBN: (collectionId) => {
            dispatch(assignAccessCodeISBN(collectionId));
        },
        sendAccessCodeISBNToPCS: (collectionId) => {
            dispatch(sendToPCS(collectionId, true));
        },
        setSPWAccessCode : (spwAccessCode) => {
            dispatch(setSPWAccessCode(spwAccessCode));
        },
        setSubscriptionLength : (length) => {
            dispatch(setSubscriptionLength(length));
        },
        createOffer : (collectionId) => {
            dispatch(createAccessCardOffer(collectionId));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AcessCodeSetup);




// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/AccessCodeSetupLink.js